import { motion } from "framer-motion";
import { SITE } from "@/config/site";
import { PlayButton } from "./PlayButton";
import { Reveal } from "./Reveal";

const DownloadCta = () => (
  <section id="download" data-testid="cta-banner-section" className="px-4 py-8 sm:px-6 lg:px-8">
    <div className="densa-grain relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-brand px-6 py-16 sm:px-12 sm:py-20 lg:px-16">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full border-[40px] border-white/5" aria-hidden="true" />
      <div className="pointer-events-none absolute -bottom-32 -left-16 h-96 w-96 rounded-full border-[50px] border-white/5" aria-hidden="true" />

      <div className="relative grid items-center gap-10 lg:grid-cols-[1fr_auto]">
        <div>
          <Reveal>
            <img src={SITE.assets.logoWhite} alt="DENSA logo" className="h-8 w-auto sm:h-10" />
            <h2 className="mt-6 max-w-xl text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
              Ready to experience DENSA?
            </h2>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-emerald-50/80">
              Download DENSA on your Android phone and see your whole clinic come together — your patients, your
              numbers and your day, finally in one place.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 flex flex-wrap items-center gap-5">
              <PlayButton variant="light" testid="cta-google-play-btn" />
              <p className="text-xs font-medium uppercase tracking-[0.18em] text-emerald-100/70" data-testid="cta-guarantee-text">
                Free to download · Android
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="hidden justify-center lg:flex">
          <motion.img
            src={SITE.assets.appIcon}
            alt="DENSA app icon"
            animate={{ y: [0, -10, 0], rotate: [0, 2, 0] }}
            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
            className="h-36 w-36 rounded-[2rem] shadow-2xl ring-4 ring-white/20"
          />
        </Reveal>
      </div>
    </div>
  </section>
);

export default DownloadCta;
